"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicationKnowledge_AdministrationGuidelines = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_MedicationKnowledge_Dosage_1 = require("./RTTI_MedicationKnowledge_Dosage");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_MedicationKnowledge_PatientCharacteristics_1 = require("./RTTI_MedicationKnowledge_PatientCharacteristics");
exports.RTTI_MedicationKnowledge_AdministrationGuidelines = t.recursion('IMedicationKnowledge_AdministrationGuidelines', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        dosage: t.array(RTTI_MedicationKnowledge_Dosage_1.RTTI_MedicationKnowledge_Dosage),
        indicationCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        indicationReference: RTTI_Reference_1.RTTI_Reference,
        patientCharacteristics: t.array(RTTI_MedicationKnowledge_PatientCharacteristics_1.RTTI_MedicationKnowledge_PatientCharacteristics)
    });
});
//# sourceMappingURL=RTTI_MedicationKnowledge_AdministrationGuidelines.js.map